/**
 * A simple publish/subscribe interface
 *
 * @module common/managers/topic
 */
import Topic from "common/managers/topic/Topic";
export default new Topic();